import { HealthcareFacilityUnit } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { BindingCreator, createTranslatedText } from '@dreryk/react-common';
import { Select } from '@dreryk/react-components';

import { statisticsTranslationKeys } from '../../../translations';

const HEALTHCARE_FACILITY_UNIT_FIELD_NAME = 'healthcareFacilityUnit';

export type HealthcareFacilityUnitSelectFieldValue = {
   [HEALTHCARE_FACILITY_UNIT_FIELD_NAME]: HealthcareFacilityUnit | null;
};

type HealthcareFacilityUnitSelectProps = {
   readonly register: BindingCreator<
      HealthcareFacilityUnitSelectFieldValue,
      typeof HEALTHCARE_FACILITY_UNIT_FIELD_NAME
   >;
   readonly healthcareFacilityUnits: HealthcareFacilityUnit[];
};

export const HealthcareFacilityUnitSelect = (props: HealthcareFacilityUnitSelectProps): JSX.Element => {
   return (
      <Select<HealthcareFacilityUnit>
         controller={props.register(HEALTHCARE_FACILITY_UNIT_FIELD_NAME, { required: true })}
         testId={HEALTHCARE_FACILITY_UNIT_FIELD_NAME}
         label={statisticsTranslationKeys.formFields.healthcareFacilityUnit.label}
         triggerLabelExtractor={(item) => item.name}
         placeholder={statisticsTranslationKeys.formFields.healthcareFacilityUnit.placeholder}
      >
         <Select.List items={props.healthcareFacilityUnits} keyExtractor={'healthcareFacilityId'}>
            {(item: HealthcareFacilityUnit) => (
               <Select.Item<HealthcareFacilityUnit>
                  item={item}
                  testId={item.id}
                  label={createTranslatedText(item.name)}
                  key={item.id}
               />
            )}
         </Select.List>
      </Select>
   );
};
